import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import Breadcrumb from '../../Components/Navigation/Breadcrumbs/Breadcrumbs';
import OutboundFeedsTemplate from './OutboundFeedsTemplatePage';
import FeedsPage from './FeedsPage';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography component={'span'}>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    [theme.breakpoints.down("sm")]: {
        width: '100%'
      },
    backgroundColor: 'transparent',
    boxShadow: 'none',
    color: theme.palette.primary.main,
    fontWeight: 'bold',
    width: "85%",
    zIndex: 0
  },
  tab:{
    fontWeight: 'bold',
    [theme.breakpoints.down("sm")]: {
      '& .MuiBox-root': {
        padding: '0px',
        },
    },
    color: theme.palette.primary.main,
  },
  largeIcon: {
    color: theme.palette.primary.main,
    margin: 'auto',
    position: 'absolute',
    top: 0, left: 0, bottom: 0, right: 0,
  },
  tabContainer: {
    marginLeft: '24px'
  },
  primary:{
    backgroundColor: theme.palette.primary.main,
  }
}));

export default function OutboundFeedsTab() {
  const classes = useStyles();
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <div className="page-container">
      <Breadcrumb/>
      <h1 className="page-title">Outbound Feeds</h1>
      <AppBar position="static" className={classes.root}>
        <Tabs value={value} onChange={handleChange} classes={{indicator: classes.primary}} className={classes.tabContainer}>
          <Tab label="Feeds" {...a11yProps(0)} className={classes.tab}/>
          <Tab label="Templates" {...a11yProps(1)} className={classes.tab}/>
        </Tabs>
      </AppBar>
      <TabPanel value={value} index={0} className={classes.tab}>
        <FeedsPage/>
      </TabPanel>
      <TabPanel value={value} index={1} className={classes.tab}>
        <OutboundFeedsTemplate/>
      </TabPanel>
    </div>
  );
}
